import React, {useEffect,useState} from 'react';
import {Helmet} from "react-helmet";
import {
  Link,
} from "react-router-dom";
import { NavHashLink } from 'react-router-hash-link';


import {connect} from 'react-redux';
import {Actions as CREATEACCOUNTACTIONS} from '../store/actions/createAccountActions';
import {Actions as WEBINARACTIONS} from '../store/actions/webinarActions';
// import {Actions as TEAMACTIONS} from './store/actions/teamActions';
// import {Actions as AUTHENTICATIONACTIONS} from './store/actions/authenticationActions';
import LeadForm from '../components/common/LeadForm'
import FeaturesSideBySide from '../components/features/FeaturesSideBySide'
import MaltaFeatures from '../components/features/MaltaFeatures'
import Team from '../components/team/Team'
import Pricing from '../components/pricing/Pricing'
import Testimonials from '../components/testimonials/Testimonials'
import Security from '../components/security/Security'

import WebinarCard from '../components/webinars/WebinarCard'

import teamMembers from '../data/teamMembers';

import AddToCalendarButton from '../components/calendar/AddToCalendarButton'
import AddToCalendarDropdown from '../components/calendar/AddToCalendarDropdown'


import MaltaFlag from '../assets/flags/malta.svg';

import { useParams} from "react-router";
import { format, addMinutes} from "date-fns";

import Vimeo from '@u-wave/react-vimeo';
import ReactPixel from 'react-facebook-pixel';
// import AddToCalendar from 'react-add-to-calendar';
import AddToCalendarHOC from 'react-add-to-calendar-hoc';

import 'react-add-to-calendar/dist/react-add-to-calendar.css'
const { sanitizeHtml } = require('../utils/sanitizeHtml');

const EMAILLIST = 9
const EVENTBRITE_WIDGET_SCRIPT_URL = 'https://www.eventbrite.co.uk/static/widgets/eb_widgets.js'

const loadEventbriteWidget = () => {
  if (window.EBWidgets || document.querySelector(`script[src="${EVENTBRITE_WIDGET_SCRIPT_URL}"]`)) return
  const script = document.createElement('script')
  script.src = EVENTBRITE_WIDGET_SCRIPT_URL
  script.async = true
  document.body.appendChild(script)
}

function Webinar({
  userInList,
  contactInList,
  subscribeToWebinar,
  addTag,
  profile,
  webinars,
  setWebinar,
  webinar,
  userSubscribedForWebinar,
  getEventDescription,
  getEventbriteEvents,
  panel,
}) {

  let { slug, country } = useParams();

  const [percentPlayed, setPercentPlayed] = useState(0)
  const [notFound, setNotFound] = useState(false)
  // const [loading, setLoading] = useState(true)

  useEffect(loadEventbriteWidget, []);

  useEffect(() => {
    // load initial data required for anywhere
    if (profile && profile.email){
      contactInList({
        email: profile.email,
        // list: EMAILLIST
      })
    }
  },[profile && profile.email]);

  useEffect(() => {
    console.log('slug',slug,webinars.find(w => w.slug == slug))

    const newWebinar = webinars.find(w => w.slug == slug)
    if (newWebinar){
      setWebinar(newWebinar)
      getEventDescription(newWebinar.webinarID);
      notFound && setNotFound(false)
    } else {
      !notFound && setNotFound(true)
    }


  }, [slug, webinars]);

  useEffect(() => {
    if(!webinars.length) getEventbriteEvents();
  }, []);
  const AddToCalendar = AddToCalendarHOC(AddToCalendarButton, AddToCalendarDropdown);

  if (!webinars.length) return (
      <main className="mt-8 sm:mt-16 md:mt-20 lg:mb-24 mb-8 sm:mb-16 md:mb-20 lg:mb-24">
        <div className="mx-auto max-w-screen-xl">
          <div className="lg:grid lg:grid-cols-12 lg:gap-8">
            <div className="px-4 sm:px-6 sm:text-center md:mx-auto lg:col-span-12 lg:text-left lg:flex lg:items-center">
              <div>
                <h1 className="mt-20 mb-20 text-4xl tracking-tight leading-10 font-extrabold text-white sm:mt-5 sm:leading-none sm:text-4xl lg:mt-6 lg:text-4xl xl:text-4xl text-center">
                  Loading Webinar Details

                  <br/>
                  <svg className="mt-5 text-white inline-block animate-spin -ml-1 mr-3 h-10 w-10 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </main>
    )

  if (notFound) return (
      <main className="mt-8 sm:mt-16 md:mt-20 lg:mb-24 mb-8 sm:mb-16 md:mb-20 lg:mb-24">
        <div className="mx-auto max-w-screen-xl">
          <div className="lg:grid lg:grid-cols-12 lg:gap-8">
            <div className="px-4 sm:px-6 sm:text-center md:max-w-2xl md:mx-auto lg:col-span-6 lg:text-left lg:flex lg:items-center">
              <div>
                <h1 className="mt-20 mb-20 text-4xl tracking-tight leading-10 font-extrabold text-white sm:mt-5 sm:leading-none sm:text-4xl lg:mt-6 lg:text-4xl xl:text-4xl">
                  Page Not Found
                </h1>
              </div>
            </div>
          </div>
        </div>
      </main>
    )

  if (!webinar) return null

  const {
    category,
    title,
    intro,
    date,
    duration,
    description,
    faq,
    // panel, // temporarily hardcoded to jon
    embed,
    tags,
    webinarID,
    price,
    location,
  } = webinar

  const onDemand = (format(new Date(date),'yyyy-MM-dd') < format(new Date(),'yyyy-MM-dd'))

  const event = {
    title,
    description: `${intro}\r\n\r\n${location}`,
    location,
    duration: duration/60,
    TZ: "Europe/Malta",
    startDatetime: format(new Date(date),"yyyyMMdd'T'hhmmss"),
    endDatetime:  format(addMinutes(new Date(date),duration),"yyyyMMdd'T'hhmmss"),
  }

  return (

    <React.Fragment>
      <Helmet>
          <title>{title}</title>
          <meta name="description" content={intro} />
          <link rel="canonical" href={`https://www.buddy.hr/${country}/webinar/${slug}`} />
      </Helmet>
      <main className="mt-8 sm:mt-16 md:mt-20 lg:mb-24 mb-8 sm:mb-16 md:mb-20 lg:mb-24">
        <div className="mx-auto max-w-screen-xl">
          <div className="lg:grid lg:grid-cols-12 lg:gap-8">
            <div className="px-4 sm:px-6 sm:text-center md:max-w-2xl md:mx-auto lg:col-span-6 lg:text-left lg:flex lg:items-center">
              <div>
                <Link to="/webinar" className="inline-flex items-center text-white bg-gray-900 rounded-full p-1 pr-2 sm:text-base lg:text-sm xl:text-base hover:text-gray-200">
                  <span className="px-3 py-0.5 text-white text-xs font-semibold leading-5 uppercase tracking-wide bg-orange-500 rounded-full">Buddy Webinar Series</span>
                  <span className="ml-4 text-sm leading-5">Click to discover other episodes</span>
                  
                  <svg className="ml-2 w-5 h-5 text-gray-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
                  </svg>
                </Link>
                <h1 className="mt-4 text-4xl tracking-tight leading-10 font-extrabold text-white sm:mt-5 sm:leading-none sm:text-6xl lg:mt-6 lg:text-5xl xl:text-6xl">


                  {!onDemand && 
                    <>
                      <span className="text-orange-400">{format(new Date(date),"dd.MM")}</span>
                      <span className="text-orange-400 text-2xl"> at {format(new Date(date),"hh:mm")}</span>
                      <br />
                    </>
                  }
                  {title}

                </h1>
                <p className="mt-3 text-base text-gray-300 sm:mt-5 sm:text-xl lg:text-lg xl:text-xl">
                  {intro}
                </p>
                {/*<p className="mt-8 text-sm text-white uppercase tracking-wide font-semibold sm:mt-10">Used by</p>
                <div className="mt-5 w-full sm:mx-auto sm:max-w-lg lg:ml-0">
                  <div className="flex flex-wrap items-start justify-between">
                    <div className="flex justify-center px-1">
                      <img className="h-9 sm:h-10" src={mcDonaldsLogo} alt="Mc Donalds"/>
                    </div>
                    <div className="flex justify-center px-1">
                      <img className="h-9 sm:h-10" src={myokaLogo} alt="Myoka Spas"/>
                    </div>
                    <div className="flex justify-center px-1">
                      <img className="h-9 sm:h-10" src={skySpiritLogo} alt="Sky Spirit"/>
                    </div>
                  </div>
                </div>*/}
              </div>
            </div>
            <div className="mt-12 sm:mt-16 lg:mt-0 lg:col-span-6">

              {/* { !eventbriteEventId && userInList && userSubscribedForWebinar && !onDemand &&
                <div className="bg-white sm:max-w-md sm:w-full sm:mx-auto sm:rounded-lg" id="leadForm">
                  <div className="px-4 py-8 sm:px-10">


                    <div>
                      <p className="text-base text-gray-600 sm:mt-5 sm:text-xl lg:text-lg xl:text-xl">{profile && ((profile.givenName && profile.givenName !== "_") || (profile.name && profile.name !== "_")) ? profile.givenName || profile.name : ''}, we've registered your interest for this webinar.</p>
                    </div>

                    <div className="mt-8" style={{position: 'relative'}}>
                      <AddToCalendar event={event}/>
                    </div>
                  </div>
                </div>
              }

              { (!eventbriteEventId || onDemand)&& userInList && !userSubscribedForWebinar &&
                <div className="bg-white sm:max-w-md sm:w-full sm:mx-auto sm:rounded-lg" id="leadForm">
                  <div className="px-4 py-8 sm:px-10">


                    <div>
                      <p className="text-base text-gray-600 sm:mt-5 sm:text-xl lg:text-lg xl:text-xl">{profile && ((profile.givenName && profile.givenName !== "_") || (profile.name && profile.name !== "_")) ? profile.givenName || profile.name : ''}</p>
                      <p className="text-base text-gray-600 sm:mt-5">Don't miss out.</p>
                    </div>

                    <div className="mt-8" style={{position: 'relative'}}>
                      <button
                        className="w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-orange-600 hover:bg-orange-500 focus:outline-none focus:border-orange-700 focus:shadow-outline-orange active:bg-orange-700 transition duration-150 ease-in-out"
                        onClick={() => {
                          console.log('subToWebinar')
                          subscribeToWebinar({
                            email: profile.email,
                            webinar: webinarID,
                            tag: tags.registered,
                          })
                        }}
                      > 
                        <svg className="-ml-1 mr-2 h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path></svg>
                        {onDemand ? `View on Demand` : `Book your spot`}
                      </button>
                    </div>
                  </div>
                </div>
              } */}

              {/* { (!eventbriteEventId && !userInList && <LeadForm list={EMAILLIST} ctaText={onDemand ? `View on Demand` : `Book your spot`} tag={`webinar.subscribed.{webinar.tag}`} onSubmit={(data) => {
                 subscribeToWebinar({
                    email: data.email,
                    webinar: webinarID,
                    tag: tags.registered,
                  })
              }}/>
              )} */}
              { !onDemand && (
                <div className="bg-white sm:max-w-md sm:w-full sm:mx-auto sm:rounded-lg" id="leadForm">
                  <div className="px-4 py-8 sm:px-10">


                    <div>
                      <p className="text-base text-gray-600 sm:mt-5 sm:text-xl lg:text-lg xl:text-xl">Get your ticket today</p>
                      <p className="text-base text-gray-600 sm:mt-5">Don't miss out.</p>
                      <p className="text-base text-gray-600 sm:mt-5 mb-10">{price ? <>Price: €{price} + VAT</> : <></>}</p>
                    </div>
                    <button onClick={() => {
                      if (!window.EBWidgets) return;
                      window.EBWidgets.createWidget({
                        widgetType: 'checkout',
                        eventId: webinarID,
                        modal: true,
                        modalTriggerElementId: 'eventbrite-widget-modal-trigger-467591818717',
                        onOrderComplete: () => {
                          // console.log("done!")
                          window.lintrk('track', { conversion_id: 13280666 });
                        },
                    });
                    }} id="eventbrite-widget-modal-trigger-467591818717" type="button" className="w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-orange-600 hover:bg-orange-500 focus:outline-none focus:border-orange-700 focus:shadow-outline-orange active:bg-orange-700 transition duration-150 ease-in-out">{price ? "Buy Tickets" : "Register Now"}</button>
                  </div>
                </div>
              )
               }
            </div>
          </div>
        </div>
      </main>

      <div className="relative py-16 bg-white overflow-hidden">
        <div className="hidden lg:block lg:absolute lg:inset-y-0 lg:h-full lg:w-full">
          <div className="relative h-full text-lg max-w-prose mx-auto">
            <svg className="absolute top-12 left-full transform translate-x-32" width="404" height="384" fill="none" viewBox="0 0 404 384">
              <defs>
                <pattern id="74b3fd99-0a6f-4271-bef2-e80eeafdf357" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
                  <rect x="0" y="0" width="4" height="4" className="text-gray-200" fill="currentColor" />
                </pattern>
              </defs>
              <rect width="404" height="384" fill="url(#74b3fd99-0a6f-4271-bef2-e80eeafdf357)" />
            </svg>
            <svg className="absolute top-1/2 right-full transform -translate-y-1/2 -translate-x-32" width="404" height="384" fill="none" viewBox="0 0 404 384">
              <defs>
                <pattern id="f210dbf6-a58d-4871-961e-36d5016a0f49" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
                  <rect x="0" y="0" width="4" height="4" className="text-gray-200" fill="currentColor" />
                </pattern>
              </defs>
              <rect width="404" height="384" fill="url(#f210dbf6-a58d-4871-961e-36d5016a0f49)" />
            </svg>
            <svg className="absolute bottom-12 left-full transform translate-x-32" width="404" height="384" fill="none" viewBox="0 0 404 384">
              <defs>
                <pattern id="d3eb07ae-5182-43e6-857d-35c643af9034" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
                  <rect x="0" y="0" width="4" height="4" className="text-gray-200" fill="currentColor" />
                </pattern>
              </defs>
              <rect width="404" height="384" fill="url(#d3eb07ae-5182-43e6-857d-35c643af9034)" />
            </svg>
          </div>
        </div>
        <div className="relative px-4 sm:px-6 lg:px-8">
          <div className="text-lg max-w-prose mx-auto mb-6">
            <p className="text-base text-center leading-6 text-orange-600 font-semibold tracking-wide uppercase">Buddy Webinar Series</p>
            <h2 className="mt-2 mb-8 text-3xl text-center leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl sm:leading-10">{title}</h2>
          </div>

          {embed && ((userInList && userSubscribedForWebinar) || profile?.isAdvisor) && 

            <div className="prose prose-lg text-gray-500 mx-auto mb-8">

                <figure>

                  <Vimeo
                    video={embed}
                    responsive={true}
                    showTitle={true}
                    showByline={false}
                    showPortrait={false}
                    autoplay={false}
                    onPlay={(e) => {
                      console.log('onPlay',e)          

                      window.gtag('event', 'video_play', {
                        'event_label': title,
                        'event_category': 'video_play',
                        'non_interaction': true
                      });

                      ReactPixel.trackCustom('video_play',{
                        content_name: title,
                        content_category: 'webinar',
                        content_type: "video",
                        // predicted_ltv: dealValue * 3,
                      });

                      addTag({
                        email: profile.email,
                        tag: tags.attended
                      })

                    }}
                    onTimeUpdate={(e) => {
                      console.log('timeupdate',e)

                      const newPercent = (e.percent * 100).toFixed(0)

                      if (percentPlayed != newPercent && ["10","25","50","75","90","100"].includes(newPercent)){
                        setPercentPlayed(newPercent)

                        window.gtag('event', 'video_play', {
                          'event_label': title,
                          'event_category': 'video_percent',
                          'value': newPercent,
                          'non_interaction': true
                        });

                        ReactPixel.trackCustom('video_percentage',{
                          content_name: title,
                          content_category: 'webinar',
                          content_type: "video",
                          percent: newPercent
                        });

                        if (newPercent == "100"){
                          addTag({
                            email: profile.email,
                            tag: tags.completed
                          })
                        }
                      }
                    }}
                  />
                  
                  {/*<figcaption>Sagittis scelerisque nulla cursus in enim consectetur quam.</figcaption>*/}
                </figure>
            </div>
             
          }

          <div className="prose prose-lg text-gray-500 mx-auto" dangerouslySetInnerHTML={{
            __html: sanitizeHtml(description)
          }}/>

        </div>
      </div>
      <div className="bg-white">
        <div className="mx-auto py-12 px-4 max-w-screen-xl sm:px-6 lg:px-8 lg:py-24">
          <div className="grid grid-cols-1 gap-12 lg:grid-cols-3 lg:gap-8">
            <div className="space-y-5 sm:space-y-4">
              <h2 className="text-3xl leading-9 font-extrabold tracking-tight sm:text-4xl">Meet our panel</h2>
              <p className="text-xl leading-7 text-gray-500">Learn from our experienced panelists.</p>
            </div>
            <div className="lg:col-span-2">
              <ul className="space-y-12 sm:grid sm:grid-cols-2 sm:gap-12 sm:space-y-0 lg:gap-x-8">

                {panel?.map(panelist => (

                  <li>
                    <div className="flex items-center space-x-4 lg:space-x-6">
                      {panelist.photo && <img
                          className="w-16 h-16 rounded-full lg:w-20 lg:h-20"
                          src={panelist.photo}
                          alt=""
                          style={{
                            objectPosition: "center",
                            objectFit: "cover"
                          }}
                        />
                      }
                      <div className="font-medium text-lg leading-6 space-y-1">
                        <h4>{panelist.name}</h4>
                        {panelist.role && <p className="text-orange-600">{panelist.role}</p>}
                        {panelist.organisation && <p className="text-gray-500">{panelist.organisation}</p>}
                      </div>
                    </div>
                  </li>
                ))}

              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-orange-600">
        <div className="max-w-2xl mx-auto text-center py-16 px-4 sm:py-20 sm:px-6 lg:px-8">
          <h2 className="text-3xl leading-9 font-extrabold text-white sm:text-4xl sm:leading-10">
            <span className="block">Boost your payroll knowledge.</span>
            <span className="block">Book your webinar spot today.</span>
          </h2>
          <p className="mt-4 text-lg leading-6 text-orange-200">Stay up to date with all of Buddy's Payroll related webinars.</p>
          <NavHashLink to="#leadForm" className="mt-8 w-full inline-flex items-center justify-center px-5 py-3 border border-transparent text-base leading-6 font-medium rounded-md text-orange-600 bg-white hover:text-orange-500 hover:bg-orange-50 transition duration-150 ease-in-out sm:w-auto">
            Book my spot
          </NavHashLink>
        </div>
      </div>


    </React.Fragment>
    
  );
}

const mapStateToProps = (state) => {

  // const {
  //   myAgreements,
  // } = state.my

  const profile = state && state.my && state.my.profile  || localStorage.getItem('userData') && JSON.parse(localStorage.getItem('userData'))

  const userInList = state.createAccount && state.createAccount.inList && state.createAccount.inList.find( item => item == EMAILLIST)

  const webinar = state.webinar

  const userSubscribedForWebinar = webinar && state.createAccount && state.createAccount.webinars && state.createAccount.webinars.find( item => item == webinar.webinarID)

  const panel = []

  // try to add panelists from webinar data
  const webinarHosts = webinar && webinar?.agenda?.map(item => item.hosts).flat()

  if (webinarHosts && webinarHosts.length){
    webinarHosts.map(host => {
        const panelist = teamMembers.find(member => member.name === host.name)
        panelist && panel.push(panelist)

        if (!panelist){
          panel.push({
            name: host.name,
            photo: host?.image?.url,
          })
        }
    })
  }

  if (panel.length == 0){
    panel.push(teamMembers[1])
  }


  return {
    webinar,
    userInList,
    userSubscribedForWebinar,
    profile,
    webinars: state.webinars.list,
    panel,
    // showSidebar: state.sidebar.show,
    // loggedIn: state.my.profile ? true : false,
  }
}

const mapDispatchToProps = dispatch => ({
  getEventDescription: (id) => dispatch(WEBINARACTIONS.getEventDescription(id)),
  getEventbriteEvents: () => dispatch(WEBINARACTIONS.getEventbriteEvents()),
  contactInList: (data) => dispatch(CREATEACCOUNTACTIONS.contactInList(data)),
  subscribeToWebinar: (data) => dispatch(CREATEACCOUNTACTIONS.subscribeToWebinar(data)),
  addTag: (data) => dispatch(CREATEACCOUNTACTIONS.addTag(data)),
  setWebinar: (webinar) => dispatch(WEBINARACTIONS.setWebinar(webinar)),
  // getProfile: () => dispatch(MYACTIONS.getProfile()),
  // isLoggedIn: () => dispatch(AUTHENTICATIONACTIONS.isLoggedIn()),
  // getDepartments: () => dispatch(TEAMACTIONS.getDepartments()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Webinar) 
